module.exports = __webpack_public_path__ + "img/appts.644b7b75.png";